export default __webpack_public_path__ + "static/tc-0a14c7ce0e865d0031b7603281f8905a.svg";